
  import TopNavBar from "./TopNavBar";

  export default {
    name: "VHeader",
    components: {TopNavBar},
    methods: {}
  }
